<style scoped>
.dicUL {
  height:250px;
  width:200px;
  text-align: left;
  text-indent: 30px;
  overflow: auto;
  border:none;
  cursor: pointer;}
</style>

<template>
 <Row>
        <i-col span="8">
         <div class="dicUL" id='province'>
           <!-- <ul data-v-5b33e310=""><li data-v-5b33e310="">北京</li><li data-v-5b33e310="">天津</li><li data-v-5b33e310="">河北省</li><li data-v-5b33e310="">山西省</li><li data-v-5b33e310="">内蒙古自治区</li><li data-v-5b33e310="">辽宁省</li><li data-v-5b33e310="">吉林省</li><li data-v-5b33e310="">黑龙江省</li><li data-v-5b33e310="">上海</li><li data-v-5b33e310="">江苏省</li><li data-v-5b33e310="">浙江省</li><li data-v-5b33e310="">安徽省</li><li data-v-5b33e310="">福建省</li><li data-v-5b33e310="">江西省</li><li data-v-5b33e310="">山东省</li><li data-v-5b33e310="">河南省</li><li data-v-5b33e310="">湖北省</li><li data-v-5b33e310="">湖南省</li><li data-v-5b33e310="">广东省</li><li data-v-5b33e310="">广西壮族自治区</li><li data-v-5b33e310="">海南省</li><li data-v-5b33e310="">重庆</li><li data-v-5b33e310="">四川省</li><li data-v-5b33e310="">贵州省</li><li data-v-5b33e310="">云南省</li><li data-v-5b33e310="">西藏自治区</li><li data-v-5b33e310="">陕西省</li><li data-v-5b33e310="">甘肃省</li><li data-v-5b33e310="">青海省</li><li data-v-5b33e310="">宁夏回族自治区</li><li data-v-5b33e310="">新疆维吾尔自治区</li><li data-v-5b33e310="">台湾</li><li data-v-5b33e310="">香港特别行政区</li><li data-v-5b33e310="">澳门特别行政区</li><li data-v-5b33e310="">海外</li></ul> -->
             <ul>
                 <template v-for="(item, index) in province">
                        <li @click="getcity(item.id)" :key="index">{{item.name}}</li>
                 </template>
             </ul>
         </div>
        </i-col>
         <i-col span="8">
                <div class="dicUL" id='city'>
             <ul>
                 <template v-for="(item, index) in city">
                        <li @click="getzone(item.id)" :key="index">{{item.name}}</li>
                 </template>
             </ul>
         </div>
         </i-col>
        <i-col span="8">
               <div class="dicUL" id='zone'>
             <ul>
                 <template v-for="(item, index) in zone">
                        <li  :key="index">{{item.name}}</li>
                 </template>
             </ul>
         </div>
        </i-col>
    </Row>
</template>
<script>
import {
  dictionaryzone,
  dictionarycity,
  dictionaryprovince
} from "../../api/dictionary";
export default {
  data() {
    return {
      province: [],
      city: [],
      zone: []
    };
  },
  methods: {
    getcity(id) {
      let par = {
        id: id
      };
      dictionarycity(par).then(res => {
        var res = res.data;
        if (res.code == 1) {
          this.city = res.data;
             this.$nextTick(function () {
          $("#city").mCustomScrollbar('update')
          $("#city").mCustomScrollbar("scrollTo","top",{scrollInertia:1000});
          })
          this.zone = [];
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getzone(id) {
      let par = {
        id: id
      };
      dictionaryzone(par).then(res => {
        var res = res.data;
        if (res.code == 1) {
          this.zone = res.data;
             this.$nextTick(function () {
          $("#zone").mCustomScrollbar('update')
          $("#zone").mCustomScrollbar("scrollTo","top",{scrollInertia:1000});
          })
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getprovince() {
      let par = {};
      dictionaryprovince(par).then(res => {
        var res = res.data;
        if (res.code == 1) {
          this.province = res.data;
          this.$nextTick(function () {
          $("#province").mCustomScrollbar('update')
          $("#province").mCustomScrollbar("scrollTo","top",{scrollInertia:1000});
          })

        } else {
          this.$Message.error(res.message);
        }
      });
    }
  },
  mounted() {
     
       $("#province").mCustomScrollbar({
					scrollButtons:{
						enable:true
          },
          theme:"dark-thick"
        });
        $("#city").mCustomScrollbar({
					scrollButtons:{
						enable:true
          },
          theme:"dark-thick"
        });
         $("#zone").mCustomScrollbar({
					scrollButtons:{
						enable:true
          },
          theme:"dark-thick"
        });
    this.getprovince();

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dictionaries/dictionary.vue